<template>
    <a-modal
        centered
        :visible="visible"
        title="邮寄信息"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="express-create" :rules="rules">
            <a-form-model-item label="选择快递公司" prop="company">
                <a-select v-model="form.company">
                    <a-select-option v-for="(item, index) in express_array" :key="index" :value="item">{{ item }}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="快递单号" prop="no">
                <a-input v-model="form.no"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        company: null,
        no: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            callback: null,
            record: null,
        },

        data() {
            return {
                submitting: false,
                form: {},
                express_array: ["顺丰快递", "邮政EMS", "申通快递", "中通快递"],
                rules: {
                    company: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "选择快递公司",
                        },
                    ],
                    no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写单号",
                        },
                    ],
                },
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                            this.form[v] = this.record[v];
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["express-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.form.invoice_id = this.record.id;
                        this.$http
                            .post("/finance/invoice_express/mail", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})

                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.form = JSON.parse(JSON.stringify(init_form));
                this.$refs["express-create"].resetFields();
            },
        },
    };
</script>
